import React, { useState, useEffect } from 'react';
import apiService from '../../services/api';

const UpdatePurchaseStatusModal = ({ show, onClose, purchase, onSuccess }) => {
  const [status, setStatus] = useState('received');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (purchase) {
      setStatus(purchase.status?.toLowerCase() || 'received');
    }
  }, [purchase, show]);

  if (!show) return null;

  const handleUpdate = async () => {
    if (!purchase || !purchase.id) return;
    
    setIsLoading(true);
    try {
      // The Ultimate POS API typically expects a partial update or a specific status update.
      // If updatePurchase expects the full object, we should be careful.
      // However, for just updating status, usually we can send just that field.
      // If it fails, we might need to fetch full purchase first.
      
      await apiService.updatePurchase(purchase.id, { 
        status: status,
        // Include minimal required fields if any (though usually not for partials)
        location_id: purchase.location_id,
        supplier_id: purchase.contact_id || purchase.supplier_id,
        transaction_date: purchase.transaction_date
      });
      
      alert('Status updated successfully');
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.error('Failed to update purchase status:', err);
      alert('Failed to update status: ' + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '450px', width: '95%' }}>
        <div className="modal-header">
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#334155' }}>Update Status</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="modal-content" style={{ padding: '1.5rem 2rem' }}>
          <div className="form-group" style={{ marginBottom: '0.5rem' }}>
            <label style={{ 
              fontWeight: '700', 
              display: 'block', 
              marginBottom: '0.75rem', 
              fontSize: '0.9rem', 
              color: '#1e293b' 
            }}>
              Purchase Status:*
            </label>
            <select 
              className="form-select" 
              value={status} 
              onChange={(e) => setStatus(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '0.6rem 0.75rem', 
                borderRadius: '6px', 
                border: '1px solid #cbd5e1',
                fontSize: '0.95rem',
                color: '#334155',
                outline: 'none',
                backgroundColor: '#fff',
                cursor: 'pointer'
              }}
            >
              <option value="new">New</option>
              <option value="received">Received</option>
              <option value="pending">Pending</option>
              <option value="ordered">Ordered</option>
            </select>
          </div>
        </div>
        <div className="modal-footer" style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '1rem',
          padding: '1.25rem 2rem',
          borderTop: '1px solid #f1f5f9',
          backgroundColor: '#f8fafc'
        }}>
          <button 
            className="modal-btn" 
            onClick={handleUpdate} 
            disabled={isLoading}
            style={{ 
              backgroundColor: '#4f46e5', 
              color: 'white',
              padding: '0.65rem 2rem',
              borderRadius: '6px',
              border: 'none',
              fontWeight: '700',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontSize: '0.95rem',
              transition: 'all 0.2s',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
            }}
            onMouseEnter={e => !isLoading && (e.currentTarget.style.backgroundColor = '#4338ca')}
            onMouseLeave={e => !isLoading && (e.currentTarget.style.backgroundColor = '#4f46e5')}
          >
            {isLoading ? 'Updating...' : 'Update'}
          </button>
          <button 
            className="modal-btn" 
            onClick={onClose}
            style={{ 
              backgroundColor: '#334155', 
              color: 'white',
              padding: '0.65rem 2rem',
              borderRadius: '6px',
              border: 'none',
              fontWeight: '700',
              cursor: 'pointer',
              fontSize: '0.95rem',
              transition: 'all 0.2s',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#1e293b'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#334155'}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePurchaseStatusModal;
